// App.tsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AdminRoutes } from "./Route";
import Header from "./DesignLayout/Header";

const App: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            {AdminRoutes.map((r) => (
              <Route key={r.path} path={r.path} element={r.element} />
            ))}
          </Routes>
        </main>
        {/* <Footer /> */}
      </BrowserRouter>
    </div>
  );
};

export default App;
